import type { PassengerPricing } from "@b2bportal/air-shopping-api";
import type { HtsAirCfarOffer } from "@b2bportal/core-types";
import { addPrices } from "@b2bportal/core-utilities";

/**
 * Creates a new passenger pricing object with CFAR premium added.
 * RBC override: handles both Fixed Pricing and Flex Pricing.
 * - Flex Pricing relies on the 'total'
 *    - If there is a 'total' field with a value > 0, it indicates that we're using Flex Pricing
 * - Fixed Pricing relies on the 'baseAmount' and 'taxAmount' values
 *    - The 'baseAmount' is the fixed points amount
 *    - The 'taxAmount' is variable and is where the CFAR price is added
 */
export const createPaxPricingWithCfar = (
  paxPricing: PassengerPricing,
  cfarOffer: HtsAirCfarOffer
): PassengerPricing => {
  if (cfarOffer == null) {
    return paxPricing;
  }

  if (paxPricing.pricing.total.fiat.value > 0) {
    return {
      ...paxPricing,
      pricing: {
        ...paxPricing.pricing,
        total: addPrices(
          paxPricing.pricing.total,
          cfarOffer.feeAmountPerPassenger
        ),
      },
    };
  }

  return {
    ...paxPricing,
    pricing: {
      ...paxPricing.pricing,
      taxAmount: addPrices(
        paxPricing.pricing.taxAmount,
        cfarOffer.feeAmountPerPassenger
      ),
    },
  };
};
